import { render } from "./PopisPage.vue?vue&type=template&id=0800d9f6&scoped=true"
import script from "./PopisPage.vue?vue&type=script&lang=js"
export * from "./PopisPage.vue?vue&type=script&lang=js"

import "./PopisPage.vue?vue&type=style&index=0&id=0800d9f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0800d9f6"]])

export default __exports__